export {}

declare global {
  function getHostname(): string
  /**
   * CAUTION: Use REACT_APP_FRONTEND_HOSTNAME not HOST (it cannot have a port number) */
  function redirectToHostname(hostname: string, pathname?: string, extraSearchParams?: URLSearchParams): void
  interface Window {
    heap: any // Heap Analytics
    dataLayer: any // Google Analytics
    fbq: any // Facebook Analytics
    AppleID?: {
      auth?: {
        init?: (config: Record<string, unknown>) => void
        signIn?: () => Promise<{
          authorization?: Record<string, unknown>
          user?: {
            email?: string
            name?: {
              firstName?: string
              lastName?: string
              givenName?: string
              familyName?: string
            }
          }
        }>
      }
    }
  }
}

// NOTE: these are declared here so we can mock them in cypress

if (!window.redirectToHostname) {
  window.redirectToHostname = (hostname: string, pathname?: string, extraSearchParams?: URLSearchParams) => {
    // eslint-disable-next-line no-restricted-properties
    const url = new URL(window.location.href)
    const searchParams = new URLSearchParams(url.search)

    if (extraSearchParams) {
      extraSearchParams.forEach((value, key) => {
        searchParams.set(key, value)
      })
    }

    url.hostname = hostname
    url.search = searchParams.toString()
    if (pathname) url.pathname = pathname

    // eslint-disable-next-line no-restricted-properties
    window.location.href = url.toString()
  }
}

if (!window.getHostname) {
  window.getHostname = () => {
    // eslint-disable-next-line no-restricted-properties
    return window.location.hostname
  }
}
